import React from 'react';

const STATUS_MAP = {
  concept: { label: 'Concept', bg: 'var(--color-surface-hover)', color: 'var(--color-text-secondary)' },
  draft: { label: 'Concept', bg: 'var(--color-surface-hover)', color: 'var(--color-text-secondary)' },
  pending: { label: 'In behandeling', bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
  sent: { label: 'Verzonden', bg: 'var(--color-accent-light)', color: 'var(--color-accent-text)' },
  verzonden: { label: 'Verzonden', bg: 'var(--color-accent-light)', color: 'var(--color-accent-text)' },
  approved: { label: 'Goedgekeurd', bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  goedgekeurd: { label: 'Goedgekeurd', bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  done: { label: 'Klaar', bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  klaar: { label: 'Klaar', bg: 'var(--color-success-light)', color: 'var(--color-success)' },
  failed: { label: 'Mislukt', bg: 'var(--color-danger-light)', color: 'var(--color-danger)' },
  new: { label: 'Nieuw', bg: 'var(--color-accent-light)', color: 'var(--color-accent-text)' },
  scheduled: { label: 'Gepland', bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
};

export default function StatusBadge({ status, customLabel }) {
  const s = STATUS_MAP[status?.toLowerCase()] || STATUS_MAP.concept;
  return (
    <span style={{
      fontSize: 10, fontWeight: 500,
      padding: '2px 7px',
      borderRadius: 4,
      background: s.bg,
      color: s.color,
      whiteSpace: 'nowrap',
    }}>
      {customLabel || s.label}
    </span>
  );
}
